import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { useSidebarStore } from '../../store/useSidebar';

/**
 * @author Claude
 * @date 2025.11.03
 * @description 사이드바 토글 플로팅 버튼 컴포넌트
 */
const SidebarToggle = () => {
  const { isVisible, toggleSidebar } = useSidebarStore();

  // 키보드 단축키 처리
  React.useEffect(() => {
    const handleKeyPress = (e: KeyboardEvent) => {
      // Ctrl+B 또는 Cmd+B
      if ((e.ctrlKey || e.metaKey) && e.key === 'b') {
        e.preventDefault();
        toggleSidebar();
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [toggleSidebar]);

  return (
    <button
      onClick={toggleSidebar}
      title={isVisible ? '메뉴 숨기기' : '메뉴 보이기'}
      className={`
        !fixed !z-[100] !top-1/2 !-translate-y-1/2
        !bg-gray-700 hover:!bg-gray-800 !text-gray-300 hover:!text-white
        !transition-all !duration-300 !ease-in-out
        ${!isVisible ? 'wave-shadow' : '!shadow-lg hover:!shadow-xl'}
        !rounded-r-lg
        !w-10 !h-32
        !flex !items-center !justify-center
        !group
        ${isVisible ? '!left-64' : '!left-0'}
      `}
      style={{
        transition: 'left 0.3s ease-in-out',
      }}
    >
      <FontAwesomeIcon 
        icon={isVisible ? faChevronLeft : faChevronRight} 
        className="!text-lg group-hover:!scale-110 !transition-transform"
      />
      
      {/* 툴팁 */}
      <span className={`
        !absolute !left-full !ml-2
        !bg-gray-800 !text-white !text-sm
        !px-3 !py-1 !rounded
        !whitespace-nowrap
        !opacity-0 group-hover:!opacity-100
        !transition-opacity !duration-200
        !pointer-events-none
        ${!isVisible ? '!block' : '!hidden'}
      `}>
        메뉴 보이기 (Ctrl+B)
      </span>
    </button>
  );
};

export default SidebarToggle;